// import http from 'src/api/axios'

const i18n:any = {
    country: 'ResGCountry',
    expressGroup: 'ResGExpressGroup'
}

export const CarrierI18nEnum = ['ResGCountry', 'ResGExpressGroup']

class Carrier {
    postal: Array<any>
    express: Array<any>
    data: any
    _lock: boolean
    _onceQueue: Array<any>
    carrierList: Array<any>
    indexList: Array<any>
    isInit: boolean
    $t: any
    constructor() {
        this.postal = []
        this.express = []
        this.data = {}
        this.carrierList = []
        this._lock = true
        this._onceQueue = []
        this.indexList = []
        this.isInit = false
        // this.updateCarrier()
        // this.initIndexList()
    }
    updateCarrier(t: any) {
        if (this.isInit) return
        this.$t = t
        // if (!this.postal.length) {
        // 获取运输商资源https://res.17track.net
        // http.get('//res.17track.net/asset/carrier/info/carrier.all.json')
        //     .then((data) => {
                // console.log(data)
                const windows:any = window
                this._setData(windows.ResGCarrier|| [])
                // localStorage.setItem('his-update-carrier-time', new Date().getTime().toString())
                // localStorage.setItem({
                //     key: 'his-carrier-lang',
                //     data: this.lang
                // })
                // uni.setStorage({
                //     key: 'his-carrier-list',
                //     data: res.data
                // })
            // })
            // .catch(err => {
            //     console.log(err)
            // })
            // .finally(() => this._notify())
        // }
    }
    processCarrierData(arr: Array<any>) {
        // const postal: Array<any> = []
        // const express: Array<any> = []
        const carrierList: Array<any> = []
        const data: any = {}
    
        arr.forEach(item => {
            data[item.key] = item
            // if (item.key.toString().length < 6) {
            //     postal.push(item)
            // } else 
            if (item._group) {
                const expressGroupItem = this.getWord('expressGroup').itemsDict.get(item._group) || {}
                if (expressGroupItem._hideSelect === 'false') {
                    carrierList.push(item)
                }
            } else {
                carrierList.push(item)
            }
        })
        carrierList.sort(this.compareAll)
        return {
            // postal,
            // express,
            carrierList,
            data
        }
    }
    getWord(word: string){
        return this.$t(i18n[word]).items || {}
    }
    processAll(list: Array<any>) {
        list.sort(this.compareAll)
        return list
    }
    
    //快递排序比较器
    compareAll(a: any, b: any) {
        const _nameA = a._name
        const _nameB = b._name
        return _nameA.localeCompare(_nameB)
    }
    initIndexList() {
        const charCodeOfA = 'A'.charCodeAt(0)
        const groups = Array(26)
        .fill('')
        .map((_, i) => ({
            title: String.fromCharCode(charCodeOfA + i),
            items: []
        }))
        console.log(groups)
    }
    getLength($t: any) {
        this.updateCarrier($t)
        return this.carrierList.length
    }
    getCarrierList($t: any) {
        this.updateCarrier($t)
        return this.carrierList
    }
    once(cb: any) {
        if (this._lock) {
            return new Promise(resolve => this._onceQueue.push([resolve, cb]))
        }

        return cb ? cb : Promise.resolve()
    }

    _setData(list: Array<any>) {
        const { carrierList, data } = this.processCarrierData(list)
        this.carrierList = carrierList
        // this.postal = postal
        // this.express = express
        this.data = data
    }

    _notify() {
        while (this._onceQueue.length) {
            const [resolve, cb] = this._onceQueue.pop()
            resolve()
            cb && cb()
        }
        this._lock = false
    }

    /**
     * 关键字搜索运输商, 依赖文件, ResGCarrier, ResGExpress, ResGCountry
     * @param inputVal {String} -- 输入的内容
     * @param all {Boolean} -- 是否全搜索
     * @return Object {{keyValue: {}, keys: [], values: []}}
     */
    searchCarrier(inputVal = '') {
        inputVal = inputVal.toLowerCase()
        return this.searchAll(inputVal)
    }

    searchAll(inputVal: string) {
        const countryKeys = this.searchCountryForVal(inputVal).keys
        const arr:any = []
        // const lang = window.YQ.configs.lang
        this.carrierList.forEach((carrier) => {
            // const name = (carrier['_name_' + lang] || carrier._name).toLowerCase()
            const _url = carrier._url
            const _countryKey = carrier._country_iso
            const _name = carrier._name.toLowerCase()
            const zhCnName = carrier['_name_zh-cn'].toLowerCase()
            const zhHkName = carrier['_name_zh-hk'].toLowerCase()
            if (
                (countryKeys.includes(_countryKey) 
                || _name.indexOf(inputVal) > -1) 
                || zhCnName.indexOf(inputVal) > -1 
                || zhHkName.indexOf(inputVal) > -1 
                || (inputVal.length > 3 && _url.toLowerCase().indexOf(inputVal) > -1)
            ) {
                arr.push(carrier)
                // if (!countryPostalMap[_countryKey]) {
                //     countryPostalMap[_countryKey] = []
                // }
                // countryPostalMap[_countryKey].push(carrier)
            }
        })
        return this.processAll(arr)
    }


    /**
     * 通过输入内容，搜索国家
     * key: countryKey
     * value: country
     * @param inputVal:string
     * @return Object {{keyValue: {}, keys: [], values: []}}
     */
    searchCountryForVal(inputVal: string) {
        const keys: Array<any> = []
        const values: Array<any> = []
        const keyValue: any = {}
        const countryItems = this.getWord('country')
        // console.log(countryItems)
        countryItems.forEach((country: any) => {
            
            if (country._mnemonic.indexOf(inputVal) > -1 || country._name.indexOf(inputVal) > -1) {
                keys.push(country.key)
                values.push(country)
                keyValue[country.key] = country
            }
        })

        return {
            keys,
            values,
            keyValue
        }
    }

     /**
     * @function
     * @description 详细内容参见yqtrack.web.uikit-v2\global-extend\vendor-yq\__utils\string-extend.js
     */
    leftFillZero(str: string, n: number) {

        let newString
        const oriLen = str.toString().length
        const maxLen = n
        let zero = ''
        let i = 0

        if (maxLen) {
        while (i < maxLen - oriLen) {
            zero += '0'
            i++
        }
        newString = zero + str
        } else {
        newString = '0' + str
        }
        return newString
    }

    /**
     * 获取邮政或快递模型, 获取不到返回空, 依赖文件, ResGCarrier, ResGExpress
     * @param carrierKey {String} -- 邮政或快递Key
     */
    getCarrier(carrierKey: string) {
        // this.updateCarrier($t)
        return carrierKey && carrierKey !== '0' ? this.data[Number(carrierKey)] : false
    }

    /**
     * 获取邮政或快递模型(邮政包括国家exCountry模型, 快递包括分组exGroup模型), 获取不到返回空, 依赖文件, ResGCarrier, ResGExpress, ResGCountry, ResGExpressGroup
     * @param carrierKey {String} -- 邮政或快递Key
     */
    getCarrierFull(carrierKey: string) {
        if (carrierKey && carrierKey !== "0") {
            const item = this.data[Number(carrierKey)]

            if (item) {
                if (item._country && !item.exCountry) {
                    item.exCountry = this.getWord('country').itemsDict.get(this.leftFillZero(item._country, 4))
                }

                if (item._group && !item.exGroup) {
                    item.exGroup = this.getWord('expressGroup').itemsDict.get(item._group)
                }

                return item
            }
        }
        return false
    }
}

export default new Carrier()